
import { Box, Grid, Typography, List, ListItem } from "@mui/material";
import React, { cloneElement } from "react";
// import logo from "../../assets/images/logo.png";
import logo from '../../assets/logo.png'

// import Footer from "./Footer";

const TermsAndConditions = () => {
  const addNumbersToListItems = (list) => {
    return cloneElement(list, {
      children: React.Children.map(list.props.children, (child, index) => {
        if (child.type === ListItem) {
          return cloneElement(child, {
            children: (
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <Typography
                  variant="body1"
                  component="span"
                  style={{
                    fontWeight: "bold",
                    marginRight: "8px",
                  }}
                  className="link-color"
                >
                  {index + 1}.
                </Typography>
                <Box>{child.props.children}</Box>
              </Box>
            ),
          });
        }
        return child;
      }),
    });
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh", // Ensure it covers the full height of the viewport
          padding: "16px",
        }}
      >
        <Box sx={{ maxWidth: "1000px", margin: "auto" }}>
          <Box className="policy-content-header-title">
            <Box class="setting-icon">
              <img src={logo} alt="app-logo" loading="lazy" />
            </Box>
            <Typography variant="h2" component="h2" className="link-color">
              TERMS AND CONDITIONS
            </Typography>
          </Box>
          <Box className="policy-content-layout">
            <Box variant="div" component="div" className="createuser-wrap">
              <Grid container spacing={4}>
                <Grid item sm={12} md={12} lg={12}>
                  <Box variant="div" component="div" className="user-detail">
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12} lg={12}>
                        <Box variant="div" component="div">
                          <Typography
                            variant="body1"
                            component="label"
                            className="label"
                          >
                            <Typography className="policy-item">
                              Effective Date: May 01, 2025
                            </Typography>
                            <Typography
                              className="policy-item"
                            // style={{ marginTop: "10px" }}
                            >
                              Welcome to RayiqLive! By accessing or using our website, services, software, and content provided through or in connection with the service (collectively, "Services"), you agree to be bound by these Terms and Conditions. Please read them carefully.
                            </Typography>
                            {addNumbersToListItems(
                              <List>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Acceptance of Terms
                                  </Typography>
                                  <Typography className="policy-item">
                                    By registering for and/or using the Services in any manner, including visiting or browsing the site, you agree to these Terms and Conditions and all other operating rules, policies, and procedures that may be published from time to time on the site by RayiqLive, each of which is incorporated by reference and may be updated without prior notice.
                                    you.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Eligibility
                                  </Typography>
                                  <Typography className="policy-item">
                                    You must be at least 18 years old to use the Services. By agreeing to these Terms, you represent and warrant that you are at least 18 years old. If you are under 18, you affirm that you have parental or guardian consent to use the Services.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Registration
                                  </Typography>
                                  <Typography className="policy-item">
                                    To access some features of the Services, you must register for an account. When registering, you agree to provide accurate, current, and complete information and to update such information promptly upon any changes. Each registration is for a single user only, unless otherwise specified.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    User Conduct
                                  </Typography>{" "}
                                  <Typography className="policy-item">
                                    {" "}
                                    You are responsible for all activities conducted through your account. You agree to use the Services only for lawful purposes and in a manner that does not infringe upon the rights of others or restrict or inhibit anyone else's use of the Services. Prohibited behaviors include harassment, transmitting obscene or offensive content, or disrupting normal service operations.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Intellectual Property
                                  </Typography>
                                  <Typography className="policy-item">
                                    {" "}
                                    All content on the Services, including text, graphics, logos, images, and software, is the property of RayiqLive or its licensors and protected by copyright and intellectual property laws. You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Services without express written permission.
                                  </Typography>
                                </ListItem>

                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Disclaimer of Warranties
                                  </Typography>
                                  <Typography className="policy-item">
                                    The Services are provided "as is" and "as available," without warranties of any kind, either express or implied. RayiqLive does not warrant that the Services will be error-free or free of viruses or other harmful components.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Limitation of Liability
                                  </Typography>
                                  <Typography className="policy-item">
                                    {" "}
                                    To the fullest extent permitted by Florida law, including but not limited to the Florida Deceptive and Unfair Trade Practices Act (FDUTPA), Chapter 501, Part II, Florida Statutes, RayiqLive shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use or inability to use the Services, even if advised of the possibility of such damages. Nothing in these Terms shall limit any liability that cannot be excluded under Florida law.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Governing Law and Jurisdiction
                                  </Typography>
                                  <Typography className="policy-item">
                                    These Terms and any disputes arising hereunder shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of law provisions. You agree to submit to the exclusive jurisdiction of the state and federal courts located in Florida for any disputes related to these Terms.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Severability
                                  </Typography>
                                  <Typography className="policy-item">
                                    If any provision of these Terms is found to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions will remain in full force and effect.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Changes to Terms
                                  </Typography>
                                  <Typography className="policy-item">
                                    RayiqLive reserves the right to modify or update these Terms at any time, at our sole discretion. Material changes will be communicated by posting an updated Terms page on our website. Continued use of the Services after changes signifies your acceptance of the new Terms.

                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Contact Us
                                  </Typography>
                                  <Typography className="policy-item">
                                    If you have any questions about these Terms, please contact us at   <span className="link-redirect" >info@rayiqlive.com</span>
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Privacy Policy
                                  </Typography>
                                  <Typography className="policy-item">
                                    Your privacy is important to us. We comply with the Florida Information Protection Act (FIPA), Chapter 501.171, Florida Statutes, which requires us to implement reasonable security measures to protect your personal information and to notify you promptly in the event of any data breach involving your personal information. By using the Services, you consent to the collection, use, and disclosure of your information as described in our Privacy Policy.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Cookies and Tracking
                                  </Typography>
                                  <Typography className="policy-item">
                                    We use cookies and similar tracking technologies to improve your experience on our site, analyze usage, and deliver personalized content and advertising. You can manage your cookie preferences through your browser settings, but disabling cookies may affect the functionality of the Services.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Termination
                                  </Typography>
                                  <Typography className="policy-item">
                                    RayiqLive reserves the right to suspend or terminate your access to the Services at any time, without prior notice or liability, for any reason including but not limited to violation of these Terms. Upon termination, your right to use the Services will immediately cease. Sections regarding Intellectual Property, Disclaimer of Warranties, Limitation of Liability, and Governing Law shall survive termination.
                                  </Typography>
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Dispute Resolution and Arbitration
                                  </Typography>
                                  <Box className="policy-container">
                                    <Typography className="policy-item link-alpha-head" variant="body1">Informal Resolution</Typography>
                                    <Typography className="policy-item">
                                      If you have a dispute with RayiqLive, please contact us at  <span className="link-redirect">info@rayiqlive.com.</span>  We will attempt to resolve the dispute informally.
                                    </Typography>
                                    <Typography className="policy-item link-alpha-head" variant="body1">Binding Arbitration</Typography>
                                    <Typography className="policy-item">
                                      Binding Arbitration: If we cannot resolve the dispute informally within 30 days, you agree that any dispute arising out of or relating to these Terms or the Services shall be resolved through binding arbitration conducted in the State of Florida, under the rules of the American Arbitration Association (AAA) or a similar recognized arbitration body. The arbitration decision will be final and binding, and judgment may be entered in any court of competent jurisdiction. This arbitration clause does not preclude either party from seeking injunctive relief in a court of competent jurisdiction to prevent actual or threatened infringement, misappropriation, or unauthorized use of intellectual property rights.
                                    </Typography>
                                  </Box>
                                 
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Florida Consumer Protection
                                  </Typography>
                                  <Box className="policy-container">
                                    <Typography className="policy-item" >
                                      Florida Consumer Protection Compliance
                                    </Typography>

                                    <Typography className="policy-item">
                                      You are entitled to protections under Florida consumer protection laws, including the Florida Deceptive and Unfair Trade Practices Act (FDUTPA), which prohibits unfair or deceptive business practices.
                                    </Typography>

                                    <Typography className="policy-item">
                                      RayiqLive commits to compliance with FDUTPA and related consumer protection laws, ensuring that our practices are transparent and fair.
                                    </Typography>

                                    <Typography className="policy-item">
                                      If you believe RayiqLive has violated your rights under Florida consumer protection laws, you may contact the Florida Attorney General’s Office Consumer Protection Division at:
                                    </Typography>

                                    <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
                                      <li>
                                        <span>Website:</span> <a href="https://myfloridalegal.com" className="link-redirect" target="_blank" rel="noopener noreferrer">myfloridalegal.com</a>
                                      </li>
                                      <li>
                                        <span>Phone:</span> <span className="link-redirect">1-866-9-NO-SCAM (1-866-966-7226)</span>
                                      </li>
                                    </Typography>
                                  </Box>
                                  {/* <Typography className="policy-item">
                                    You are entitled to protections under Florida consumer protection laws, including the Florida Deceptive and Unfair Trade Practices Act (FDUTPA), which prohibits unfair or deceptive business practices. RayiqLive commits to compliance with FDUTPA and related consumer protection laws, ensuring that our practices are transparent and fair.
                                    If you believe RayiqLive has violated your rights under Florida consumer protection laws, you may contact the Florida Attorney General’s Office Consumer Protection Division at:
                                    - Website: myfloridalegal.com
                                    - Phone: 1-866-9-NO-SCAM (1-866-966-7226)

                                  </Typography> */}
                                </ListItem>
                                <ListItem>
                                  <Typography
                                    variant="body1"
                                    component="span"
                                    className="link-color-head"
                                  >
                                    Mandatory Disclosures
                                  </Typography>

                                  <Box className="policy-container">
                                    <Typography className="policy-item link-alpha-head" variant="body1">A. No Warranty Disclaimer</Typography>
                                    <Typography className="policy-item">
                                      RayiqLive makes no guarantees regarding the accuracy, reliability, or completeness of the Services.
                                      The Services are provided “as is” and “as available,” without any express or implied warranties,
                                      including but not limited to warranties of merchantability, fitness for a particular purpose,
                                      or non-infringement.
                                    </Typography>

                                    <Typography className="policy-item link-alpha-head" variant="body1">B. Data Collection and Use</Typography>
                                    <Typography className="policy-item">
                                      In accordance with the Florida Information Protection Act (FIPA), Chapter 501.171, Florida Statutes,
                                      we disclose that we collect personal information from you to provide and improve our Services.
                                      We use commercially reasonable security measures to protect your data and notify you of any
                                      unauthorized access or data breach as required by law.
                                    </Typography>

                                    <Typography className="policy-item link-alpha-head" variant="body1">C. Consumer Rights Under FDUTPA</Typography>
                                    <Typography className="policy-item">
                                      Under the Florida Deceptive and Unfair Trade Practices Act (FDUTPA), consumers have the right
                                      to be free from unfair or deceptive business practices. If you believe you have been harmed by a
                                      violation of FDUTPA, you may file a complaint with the Florida Attorney General’s Consumer Protection Division.
                                    </Typography>

                                    <Typography className="policy-item link-alpha-head" variant="body1">D. Third-Party Links and Services</Typography>
                                    <Typography className="policy-item">
                                      Our Services may contain links to third-party websites or services not owned or controlled by RayiqLive.
                                      We are not responsible for the content, privacy policies, or practices of any third parties, and encourage
                                      you to review their terms and privacy policies before use.
                                    </Typography>

                                    <Typography className="policy-item link-alpha-head" variant="body1">E. Changes to the Terms</Typography>
                                    <Typography className="policy-item">
                                      In compliance with Florida law, we will notify users of material changes to these Terms by posting the
                                      updated Terms on our website and indicating the effective date. Continued use of the Services after
                                      notification constitutes acceptance of the changes.
                                    </Typography>
                                  </Box>
                                </ListItem>

                                <Box className="policy-container">
                                  <Typography className="policy-item link-color-head" color="primary" variant="h6">
                                    Florida Consumer Rights Summary
                                  </Typography>

                                  <Typography className="policy-item">
                                    As a consumer in Florida, you have important rights under state law designed to protect you from unfair or deceptive business practices. These include:
                                  </Typography>

                                  <Typography className="policy-item" component="ul" sx={{ pl: 3 }}>
                                    <li>
                                      The right to be free from misleading advertising and unfair business practices under the Florida Deceptive and Unfair Trade Practices Act (FDUTPA).
                                    </li>
                                    <li>
                                      The right to have your personal data protected under the Florida Information Protection Act (FIPA), which requires businesses to safeguard your data and notify you if it is compromised.
                                    </li>
                                    <li>
                                      The right to file complaints with the Florida Attorney General’s Consumer Protection Division if you believe your rights have been violated.
                                    </li>
                                    <li>
                                      Access to informal dispute resolution and arbitration processes before pursuing litigation.
                                    </li>
                                  </Typography>

                                  <Typography className="policy-item" sx={{ mt: 1 }}>
                                    For more information or to file a complaint, visit <a href="https://myfloridalegal.com" className="link-redirect" target="_blank" rel="noopener noreferrer">myfloridalegal.com</a> or call <span className="link-redirect">1-866-9-NO-SCAM (1-866-966-7226)</span>.
                                  </Typography>
                                </Box>

                              </List>

                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
          {/* <Footer /> */}
        </Box>
      </Box>
    </>
  );
};

export default TermsAndConditions;